import * as jsonpatch from "fast-json-patch";
// import { ProgramSession, SessionSearchFilter, ProgramSessionSearchResponse, ProgramSessionCreateRequest } from '@api/entities';
import { IWorkoutSessionApiClients, WorkoutSessionApiClients } from "./workout.session.client";
import { ProgramSession, ProgramSessionCreateRequest, ProgramSessionSearchResponse, ProgramSessionUpdatDateRequest, SessionSearchFilter } from "src/api/entities";

export interface IWorkoutSessionApiService {
    create(WorkoutSession: ProgramSessionCreateRequest): Promise<ProgramSession>;
    duplicate(WorkoutSession: ProgramSessionCreateRequest): Promise<ProgramSession>;
    getById(id: number): Promise<ProgramSession>;
    updateDate(id: number, request: ProgramSessionUpdatDateRequest): Promise<ProgramSession>;
    edit(oldWorkoutSession: ProgramSession, updatedWorkoutSession: ProgramSession): Promise<ProgramSession>;
    search(
        page: number,
        size: number,
        query?: string,
        sort?: { [key: string]: string | undefined },
        filter?: SessionSearchFilter
    ): Promise<ProgramSessionSearchResponse>;
    delete(id: number): Promise<{ [key: string]: boolean; }>
}

export class WorkoutSessionApiService implements IWorkoutSessionApiService {
    private static instance: WorkoutSessionApiService;
    private api: IWorkoutSessionApiClients;

    private constructor(basePath: string) {
        this.api = WorkoutSessionApiClients.getInstance(basePath);
    }

    static getInstance(basePath: string) {
        if (WorkoutSessionApiService.instance == null) {
            WorkoutSessionApiService.instance = new WorkoutSessionApiService(basePath);
        }
        return WorkoutSessionApiService.instance;
    }

    async create(sessionCreateRequest: ProgramSessionCreateRequest): Promise<ProgramSession> {
        return (await this.api.workoutSession.create9(sessionCreateRequest)).data;
    }

    async duplicate(sessionCreateRequest: ProgramSessionCreateRequest): Promise<ProgramSession> {
        return (await this.api.workoutSession.duplicate2(sessionCreateRequest)).data;
    }

    async getById(id: number): Promise<ProgramSession> {
        return (await this.api.workoutSession.get8(id)).data;
    }

    async updateDate(id: number, request: ProgramSessionUpdatDateRequest): Promise<ProgramSession> {
        return (await this.api.workoutSession.update3(id, request)).data;
    }

    async delete(id: number): Promise<{ [key: string]: boolean; }> {
        const response: { [key: string]: boolean; } = (await this.api.workoutSession.delete9(id)).data
        return response
    }

    async edit(oldWorkoutSession: ProgramSession, updatedWorkoutSession: ProgramSession): Promise<ProgramSession> {
        const requestPatch: any = jsonpatch.compare(oldWorkoutSession, updatedWorkoutSession);
        const WorkoutSession: ProgramSession = (
            await this.api.workoutSession.patch5(oldWorkoutSession.id!, requestPatch)
        ).data;
        return WorkoutSession;
    }

    async search(
        page: number,
        size: number,
        query?: string,
        sort?: { [key: string]: string },
        filter?: SessionSearchFilter
    ): Promise<ProgramSessionSearchResponse> {

        

        return (
            await this.api.workoutSession.searchWithoutProgram({
                page,
                size,
                query,
                sort,
                filter,
            })
        ).data;
    }
}
